import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

type DeleteCommentV2Params = {
  scenarioBuilderClient: ScenarioBuilderClient;
  scenarioId: string;
  commentId: string;
};

export const deleteCommentV2 = ({
  scenarioBuilderClient,
  scenarioId,
  commentId,
}: DeleteCommentV2Params) => {
  return scenarioBuilderClient.scenarios.deleteComment({
    scenarioUuid: scenarioId,
    commentUuid: commentId,
  });
};
